export default "/images/vendor/flag-icon-css/flags/4x3/sn.svg?5d2dde7343ab4f2028909cf2ebe29186";